export default {
  supplyPluginList: {
    method: 'post',
    url: '/client/supply/plugins/list'
  },
  supplyPluginListById: {
    method: 'post',
    url: '/client/supply/plugins/list/ID'
  },
  supplyPluginCreate: {
    method: 'post',
    url: '/client/supply/plugins'
  },
  supplyPluginUpdate: {
    method: 'put',
    url: '/client/supply/plugins'
  },
  supplyPluginDelete: {
    method: 'delete',
    url: '/client/supply/plugins'
  }
}
